<!--  -->
<template>
    <div class="UserMoney" v-if="wxData && wxData.id">
        <div>
            <span>检索余数：</span>
            <span class="money ">{{queryCount}}</span>
            <span class="ge queryCount">次</span>
            <span class="queryCount">/</span>
            <span >吉祥币：</span>
            <span class="money">{{ luckyCount }} </span>
            <span class="ge">个</span>
            <span class="ge"></span>
            <span class="xiaohao">预计未来需消耗 </span>
            <span class="yuji">{{ consumeCount }}</span>
            <span class="ge">个</span>
        </div>

        <div class="chognzhi" v-if="wxData.is_free == 0 && $route.name !== 'Recharge'" @click="freeReceive">
            '◡'免费->领取
        </div>
        <div v-else>
            <router-link to="/BigData/My/Recharge">
                <div class="chognzhis" v-show="$route.name !== 'Recharge'">去充值</div>
            </router-link>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import { freeReceive } from '@/api'
export default {
    name: "UserMoney",
    components: {},
    data() {
        return {
            showfree: false
        };
    },
    computed: {
        // 获取store中的数据,mapStates数组写法
        ...mapState('home', ['luckyCount', 'expiredCount', 'consumeCount', 'wxData']),
    },
    watch: {
        wxData: {
            immediate: true,
            deep: true,// 启用深度监视
            handler(newValue, oldValue) {

            },
        }
    },
    methods: {
        //借助mapActions生成对应的方法，方法中会调用dispatch去联系actions(数组写法)
        ...mapActions('home', ['getGlobalInfos', 'getUserInofo']),
        async freeReceive() {
            try {
                let req = await freeReceive({ wxid: this.wxData.id })
                if (req.state == 'ok') {
                    this.$message({ message: req.message, type: 'success', offset: 500, duration: 1500 })
                    // 重新获取吉祥币
                    await this.getGlobalInfos()
                    this.$set(this.wxData, 'is_free', 1);
                } else {
                    this.$message({ message: req.message, type: 'error', offset: 500, duration: 1500 })
                }

            } catch (error) {
                console.error(error)
            }
        }
    },
    async mounted() {
        await this.getGlobalInfos()
    },
}
</script>
<style lang='scss' scoped>
a {
    text-decoration: none;
}

.UserMoney {
    display: flex !important;
    align-items: center !important;
}

.chognzhi {
    margin-left: 40px;
    padding: 8px 16px;
    color: white;
    background-color: orange;
    border-radius: 4px;
    cursor: pointer;
}

.chognzhis {
    margin-left: 40px;
    padding: 8px 16px;
    color: white;
    background-color: orangered;
    border-radius: 4px;
    cursor: pointer;
}

.money {
    font-weight: bold;
    color: orangered;
    font-size: 17px;
}

.yuji {
    font-weight: bold;
    color: orangered;
    font-size: 17px;
}

.xiaohao {
    margin-left: 8px;
}

.ge {
    display: inline-block;
    margin-left: 5px;
}
.queryCount{
    display: inline-block;
    margin-right: 20px;
}
</style>